/**
 * @ComponentFor Avensia.Shop.Features.Shared.Blocks.RowLayout.RowLayoutBlockViewModel
 */
import React from "react";
import classnames from "classnames";
import { contentAreaItems, epiPropertyValue } from "@avensia/nitro5-scope-episerver";
import BoxLayout from "Shared/BoxLayout";
import * as styles from "./base.scss";
import editorAttributesFor from "Shared/editor-attributes-for";
const RowLayoutContentArea = (props) => {
    return (React.createElement(BoxLayout, Object.assign({}, editorAttributesFor(props.propertyName, props.className), { appearance: { gutter: props.spacingBetweenBlocks }, className: classnames({ [styles.fillPageWidth]: props.fillPageWidth }), layout: props.layout }), contentAreaItems(props.propertyName, props.items)));
};
RowLayoutContentArea.supportsPropertyForIntegration = true;
export default (props) => (React.createElement("div", { className: classnames(styles["layout_" +
        props.layout
            .map((r) => (typeof r === "string" ? r : r[0]))
            .join("_")]) },
    React.createElement(RowLayoutContentArea, Object.assign({}, {
        spacingBetweenBlocks: props.spacingBetweenBlocks,
        fillPageWidth: props.fillPageWidth,
        layout: props.layout,
        propertyName: "block",
        items: epiPropertyValue(props.block.items).items,
    }))));
